import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '../../helpers/methods'

let {getNested, deepCopy} = helpers

// state
export const state = {}

// getters
export const getters = {
    settings: state => (key) => {
        if (!key) return deepCopy(state)
        return getNested(key, state, '[UNDEFINED]') === '[UNDEFINED]' ? undefined : getNested(key, state)
    }
}

// mutations
export const mutations = {
    [types.SET_SETTING] (state, {key, value}) {
        let curr = state
        key.split('.').forEach((step, index, array) => {
            Vue.set(curr, step, index === array.length - 1 ? value : curr[step] || {})
            curr = curr[step]
        })
    }
}

// actions
export const actions = {
    set ({ commit }, {key, value}) {
        commit(types.SET_SETTING, {key, value})
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/local.js